import { en } from './en';
import { ru } from './ru';
const translations = {
    en,
    ru,
};
function translate(key, args) {
    const dictionary = translations[getLanguage()];
    const template = dictionary[key];
    if (template === undefined)
        return `[${key}]`;
    const [firstArg] = args;
    const isNamed = args.length === 1 && typeof firstArg === 'object' && firstArg !== null;
    const values = isNamed ? firstArg : args;
    // `{1}` is the first positional argument, `{name}` is a key of the params object.
    return template.replace(/\{(\w+)\}/g, (placeholder, token) => {
        const value = Array.isArray(values) ? values[Number(token) - 1] : values[token];
        return value === undefined ? placeholder : String(value);
    });
}
// t - Translate (to chosen language).
// Named: t('validation.max.fraction.digits', { digits: 3 }) fills {digits}.
// Positional: t('some.legacy.key', 'a', 'b') fills {1} and {2}.
function t(key, ...args) {
    return translate(key, args);
}
/**
 * Escape hatch for keys assembled at runtime, when the possible keys are not known at compile time.
 * Neither the key nor the params are checked — use `t` everywhere the key is a literal.
 *
 * @example
 * // Key built from a route param typed as `string`:
 * <NavLink to={`/placement/${tab}`}>{tDynamic(`${tab}.label`)}</NavLink>
 *
 * // Key built from a server-provided error code:
 * showApiErrorSnackbar(tDynamic(`error.${response.errorCode}`));
 *
 * // Wrong — the key is known here, `t` gives autocomplete and catches typos:
 * // tDynamic('weight.label')
 */
function tDynamic(key, ...args) {
    return translate(key, args);
}
function getLanguage() {
    // TODO: read from redux instead of hitting localStorage on every call.
    return 'ru';
}
export { getLanguage, t, tDynamic };
